<ng-container *ngIf="report; else elseTemplate">
  <div class="container">
    <div class="row head">
      <div class="col-12">
        <span class="title" i18n="report_detail|@@report_detail">Détail du rapport</span>
      </div>
    </div>
    <div class="row key-value">
      
      <!-- 1I8n -->
      <div class="col-12" >
        <p class= "notes">Notes</p>
        <textarea (change)="saveChanges()" class="input-notes"[(ngModel)]="report.notes">
        </textarea>
      </div>
      
      <div class="col-12" i18n="report_detail|@@report_date_data" *ngIf="report.reportCreatedAt">Date et heure du
        rapport : {{reportCreatedAt}}</div>
    </div>
    <div class="row key-value">
      <div class="col-12" i18n="report_detail|@@scan_date_data">Date et heure du scan :
        {{this.report.tchekPtr.tchekCreatedAt | date:'long':'':'fr'}}</div>
    </div>
    <div class="row key-value">
      <div class="col-12" i18n="report_detail|@@hour_date_data">Horodatage :
        {{this.report.tchekPtr.tchekCreatedAt | date:'long':'':'fr'}}</div>
    </div>
    <div class="row key-value">
      <div class="col-12" i18n="report_detail|@@gps_data">Coordonnées GPS : {{location}}</div>
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="container">
    <div class="row head">
      <div class="col-12">
        <span class="title" i18n="report_detail|@@report_detail">Détail du rapport</span>
      </div>
    </div>
    <div class="row ">
      <div class="col-12 col-lg-10">
        <content-loader [width]="900" [height]="45">
          <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
        </content-loader>
      </div>
      <div class="col-12 col-lg-10">
        <content-loader [width]="900" [height]="45">
          <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
        </content-loader>
      </div>
      <div class="col-12 col-lg-10">
        <content-loader [width]="900" [height]="45">
          <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
        </content-loader>
      </div>
      <div class="col-12 col-lg-10">
        <content-loader [width]="900" [height]="45">
          <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
        </content-loader>
      </div>

    </div>
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/report-details/report-details.component.html